/** The import worker started from its bundle under the app's Trusted Types policy (part 17; part 15, table T). */
import type { WorkerSource } from '../preview/platform.ts';
import type { ImportWorker } from './host.ts';

/** T6, T7: a function starting an import worker (a module worker) for each import (decision 56: one per import). */
export function importWorker(source: WorkerSource<ImportWorker>): () => ImportWorker {
  return () => new source.Worker(source.trusted(source.url), { type: 'module', name: 'import' });
}
